module.exports = __webpack_public_path__ + "h5/img/funv-nav3.9caeabb3.png";